import {
	GET_DIVISIONORDER_LIST,
	GET_DIVISIONORDER_LIST_SUCCESS,

	UPDATE_ORDER_ID_FROM_ORDER_PAGE,
	UPDATE_ORDER_ID_FROM_ORDER_PAGE_SUCCESS,
	EDIT_ORDER_FOR_ORDER_PAGE_SUCCESS,
	EDIT_ORDER_FOR_ORDER_PAGE,
	DELETE_ORDER_FOR_ORDER_PAGE,
	DELETE_ORDER_FOR_ORDER_PAGE_SUCCESS,
	GO_BUTTON_FOR_ORDER_PAGE_SUCCESS,
	GO_BUTTON_FOR_ORDER_PAGE,
	SAVE_ORDER_FROM_ORDER_PAGE_SUCCESS,
	SAVE_ORDER_FROM_ORDER_PAGE,
	GET_ORDER_LIST_PAGE,
	GET_ORDER_LIST_PAGE_SUCCESS,
	ORDER_APPROVAL_ACTION,
	ORDER_APPROVAL_ACTION_SUCCESS,
	GET_ORDER_APPROVAL_DETAIL,
	GET_ORDER_APPROVAL_DETAIL_SUCCESS,
	ORDER_API_ERROR_ACTION,
	POST_ORDER_CONFIRM_API,
	POST_ORDER_CONFIRM_API_SUCCESS,
	ORDER_SINGLE_GET_API,
	ORDER_SINGLE_GET_API_SUCCESS,
	ORDER_ITEMS,
	ORDER_ITEMS_SUCCESS,
	ADD_ORDER_ITEMS,
	ADD_ORDER_ITEMS_SUCCESS,
	LIST_BUTTON_LOADING_END,
	LIST_BUTTON_LOADING_START,
	MANUALLY_ORDER_CLOSE,
	MANUALLY_ORDER_CLOSE_SUCCESS,
	ORDER_ACCOUNTING_APPROVAL,
	ORDER_ACCOUNTING_APPROVAL_SUCCESS,
} from './actionType'

export const GoButton_For_Order_Add = (config) => ({
	type: GO_BUTTON_FOR_ORDER_PAGE,
	config
});

export const GoButton_For_Order_AddSuccess = list => ({
	type: GO_BUTTON_FOR_ORDER_PAGE_SUCCESS,
	payload: list,
})


export const Order_Items = (config) => ({
	type: ORDER_ITEMS,
	config
});

export const Order_Items_Success = list => ({
	type: ORDER_ITEMS_SUCCESS,
	payload: list,
})

export const Add_Order_Items = (config) => ({
	type: ADD_ORDER_ITEMS,
	config
});

export const Add_Order_Items_Success = list => ({
	type: ADD_ORDER_ITEMS_SUCCESS,
	payload: list,
})

export const ManuallyOrderClose = (config = {}) => ({
	type: MANUALLY_ORDER_CLOSE,
	config,
});

export const ManuallyOrderCloseSuccess = (resp) => ({
	type: MANUALLY_ORDER_CLOSE_SUCCESS,
	payload: resp,
});

//get listpage api
export const getOrderListPage = (config = {}) => ({
	type: GET_ORDER_LIST_PAGE,
	config,
});

export const getOrderListPageSuccess = (resp) => ({
	type: GET_ORDER_LIST_PAGE_SUCCESS,
	payload: resp,
});


export const saveOrderAction = (config = {}) => ({
	type: SAVE_ORDER_FROM_ORDER_PAGE,
	config,
});
export const saveOrderActionSuccess = (resp) => ({
	type: SAVE_ORDER_FROM_ORDER_PAGE_SUCCESS,
	payload: resp
});


export const editOrderId = (config = {}) => ({
	type: EDIT_ORDER_FOR_ORDER_PAGE,
	config,
});
export const editOrderIdSuccess = (resp) => ({
	type: EDIT_ORDER_FOR_ORDER_PAGE_SUCCESS,
	payload: resp,
});

export const viewOrderSingleget = (config = {}) => ({
	type: ORDER_SINGLE_GET_API,
	config,
});
export const orderSinglegetSuccess = (resp) => ({
	type: ORDER_SINGLE_GET_API_SUCCESS,
	payload: resp,
});


export const updateOrderIdAction = (config = {}) => ({
	type: UPDATE_ORDER_ID_FROM_ORDER_PAGE,
	config,
});
export const updateOrderIdSuccess = (data) => ({
	type: UPDATE_ORDER_ID_FROM_ORDER_PAGE_SUCCESS,
	payload: data,
});


export const deleteOrderId = (config) => ({
	type: DELETE_ORDER_FOR_ORDER_PAGE,
	config,
});
export const deleteOrderIdSuccess = (data) => ({
	type: DELETE_ORDER_FOR_ORDER_PAGE_SUCCESS,
	payload: data,
});


export const getDivisionOrders = () => ({
	type: GET_DIVISIONORDER_LIST,
});

export const getDivisionOrdersSuccess = orders => ({
	type: GET_DIVISIONORDER_LIST_SUCCESS,
	payload: orders,
})



export const getOrderApprovalDetailAction = (config) => ({
	type: GET_ORDER_APPROVAL_DETAIL,
	config
});

export const getOrderApprovalDetailActionSucc = resp => ({
	type: GET_ORDER_APPROVAL_DETAIL_SUCCESS,
	payload: resp,
})
export const orderApprovalAction = (config) => ({
	type: ORDER_APPROVAL_ACTION,
	config
});

export const orderApprovalActionSuccess = resp => ({
	type: ORDER_APPROVAL_ACTION_SUCCESS,
	payload: resp,
})


export const postOrderConfirms_API = (config = {}) => ({ // save Action
	type: POST_ORDER_CONFIRM_API,
	config,
});

export const postOrderConfirms_API_Success = (resp) => ({ // Save success
	type: POST_ORDER_CONFIRM_API_SUCCESS,
	payload: resp,
});

export const orderApiErrorAction = () => ({
	type: ORDER_API_ERROR_ACTION,
})

export const sendActionLoad = (config = {}) => ({
	type: LIST_BUTTON_LOADING_START,
	config,
})

export const sendActionLoadStop = resp => ({
	type: LIST_BUTTON_LOADING_END,
	payload: resp,

});

export const orderAccountingApprovalAction = (config = {}) => ({
	type: ORDER_ACCOUNTING_APPROVAL,
	config,
});

export const orderAccountingApprovalActionSuccess = (resp) => ({
	type: ORDER_ACCOUNTING_APPROVAL_SUCCESS,
	payload: resp,
});